import { mode_edit, mode_view } from '../../../../../../views/my-store/google-profile';

export default {
  title: 'Profil Google',
  sections: {
    current_profile: {
      [mode_view]: 'Profil connecté',
      [mode_edit]: 'Modifier le profil connecté',
    },
  },
  form: {
    google_places_id: {
      label: 'Nom sur Google Maps',
    },
    address: {
      label: 'Adresse',
    },
    rating: {
      label: 'Note',
    },
    opening_hours: {
      label: "Horaires d'ouverture",
    },
    phone_number: {
      label: 'Numéro de téléphone',
    },
    pictures: {
      label: 'Images',
    },
  },
  labels: {
    no_place_connected: "Ce restaurant n'a pas de profil Google connecté",
    fields_to_sync: 'Infos à synchroniser depuis {{name}}',
  },
  buttons: {
    save: 'Enregistrer',
    change: 'Modifier',
    cancel: 'Annuler',
  },
  toasts: {
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
    changes_got_saved: 'Modifications enregistrées',
  },
};
